import React from "react";
import componentRegistry from "./ComponentRegistry";

// Cache so each route name is only ever wrapped in React.lazy() ONCE.
// This matters: if ImportComponent were called on every render (it is --
// MainContent calls it inside a .map() on every re-render of the route
// list) and it did `React.lazy(() => import(...))` fresh each time, React
// would treat it as a brand-new component type on every render and remount
// (and re-suspend) it instead of reusing the loaded module.
const lazyCache = new Map();

/**
 * Resolves a route.component string (e.g. "AcaAddStudentView") to its
 * React.lazy-wrapped component, or null if the name isn't registered --
 * same contract as the old switch/case `default: return null`.
 */
export const ImportComponent = (route) => {
  if (!route) return null;

  if (!lazyCache.has(route)) {
    const loader = componentRegistry[route];
    if (!loader) {
      // Unknown route name -- don't cache a miss as null forever in case
      // the registry is ever extended at runtime; just report it.
      console.warn(`ImportComponent: no component registered for "${route}"`);
      return null;
    }
    lazyCache.set(route, React.lazy(loader));
  }

  return lazyCache.get(route);
};

export default ImportComponent;